var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal-company-drive",
      attrs: { id: "idModalCompanyDrive" }
    },
    [
      _c("div", { staticClass: "wrap-content" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-start justify-content-between" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("i", {
              staticClass: "fa fa-close close-popup",
              on: {
                click: function($event) {
                  _vm.$emit("close-popup", null)
                }
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex justify-content-between align-items-center" },
          [
            _c("div", { staticClass: "breadcrumbs" }, [
              _c(
                "ol",
                _vm._l(_vm.breadCrumbs, function(breadcrumb, index) {
                  return _c("li", { key: breadcrumb.id }, [
                    index !== _vm.breadCrumbs.length - 1
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center cursor-pointer"
                          },
                          [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.handleChangeFolder(breadcrumb.id)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(breadcrumb.name) +
                                    "\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v(" > ")])
                          ]
                        )
                      : _c("div", [_vm._v(_vm._s(breadcrumb.name))])
                  ])
                })
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "search-folder" }, [
              _c("i", { staticClass: "fa fa-search" }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.search,
                    expression: "search"
                  }
                ],
                attrs: { type: "text", placeholder: "Search..." },
                domProps: { value: _vm.search },
                on: {
                  keyup: _vm.handleSearch,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.search = $event.target.value
                  }
                }
              })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wrap-table-list", attrs: { id: "wrapTable" } },
          [
            _c("table", { staticClass: "table-list" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  !_vm.isLoading && _vm.companyDatas.length === 0
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticStyle: { "text-align": "center" },
                            attrs: { colspan: "4" }
                          },
                          [
                            _vm._v(
                              "\n              No data available in table\n            "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isLoading && _vm.companyDatas.length > 0
                    ? _vm._l(_vm.companyDatas, function(data) {
                        return _c(
                          "tr",
                          {
                            key: data.id,
                            class: {
                              selected: _vm.folderSelected.includes(data.id)
                            },
                            on: {
                              click: function($event) {
                                _vm.handleClick(data.id, data.kind)
                              }
                            }
                          },
                          [
                            _c("td", { staticClass: "file-name" }, [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/icon/" +
                                    _vm.getIcon(data.file_type)),
                                  alt: "icon-" + data.name
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(data.name))])
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(data.size || "-"))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$moment(data.created_at)
                                    .format("DD MMMM YYYY HH:mm:SS")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$moment(data.updated_at)
                                    .format("DD MMMM YYYY HH:mm:SS")
                                )
                              )
                            ])
                          ]
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLoading || _vm.isLoadingMore
                    ? _vm._l(6, function(i) {
                        return _c(
                          "tr",
                          { key: "row-" + i },
                          _vm._l(4, function(j) {
                            return _c("td", { key: "column-" + j }, [
                              _c("div", { staticClass: "skeleton-table" })
                            ])
                          })
                        )
                      })
                    : _vm._e()
                ],
                2
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex justify-content-end" }, [
          _c(
            "button",
            {
              staticClass: "button-border mr-2",
              on: {
                click: function($event) {
                  _vm.$emit("close-popup", null)
                }
              }
            },
            [_vm._v("\n        Close\n      ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button-blue",
              attrs: { disabled: _vm.isDisabled },
              on: { click: _vm.selectFolder }
            },
            [_vm._v("\n        Select Folder\n      ")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-modal" }, [
      _c("img", {
        staticClass: "modal-logo",
        attrs: {
          src: require("@/assets/logo/drive-logo.svg"),
          alt: "drive-logo"
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "title-text" }, [_vm._v("Drive")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Size")]),
        _vm._v(" "),
        _c("th", [_vm._v("Created At")]),
        _vm._v(" "),
        _c("th", [_vm._v("Updated At")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27038bee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27038bee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/popup/ModalCompanyDrive.vue
// module id = null
// module chunks = 